// src/utils/dateUtils.ts
// Global date formatting utilities for European format

export const formatDate = (dateString: string | Date): string => {
  const date = new Date(dateString);
  return date.toLocaleString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

export const formatDateTime = (dateString: string | Date): string => {
  const date = new Date(dateString);
  return date.toLocaleString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatDateTimeShort = (dateString: string | Date): string => {
  const date = new Date(dateString);
  return date.toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatDateForInput = (dateString: string | Date): string => {
  const date = new Date(dateString);
  // HTML date inputs expect YYYY-MM-DD format regardless of locale
  return date.toISOString().split('T')[0];
};

export const formatDateFromInput = (inputValue: string): string => {
  // Convert HTML date input (YYYY-MM-DD) to display format (DD.MM.YYYY)
  const [year, month, day] = inputValue.split('-');
  return `${day}.${month}.${year}`;
};

// Set default locale for the entire app
export const setGermanLocale = () => {
  // This will affect toLocaleString() calls without explicit locale
  if (typeof window !== 'undefined') {
    // For client-side
    Object.defineProperty(Date.prototype, 'toLocaleString', {
      value: function(locale = 'de-DE', options = {}) {
        return Intl.DateTimeFormat(locale, options).format(this);
      }
    });
  }
};
